import React from 'react';
import PropTypes from 'prop-types';
import { groupBy } from 'lodash';
import moment from 'moment';
import bem from 'helpers/bem';
import { IconArrowRight } from 'icons';
import TimeslotGroup from './TimeslotGroup';

class TimeslotPicker extends React.Component {
  static propTypes = {
    displayPeriodLength: PropTypes.string.isRequired,
    timeslots: PropTypes.arrayOf(PropTypes.string).isRequired,
    selected: PropTypes.string.isRequired,
    setTimeslot: PropTypes.func.isRequired,
  };

  static dayFormat = 'YYYY-MM-DD';

  static weekFor(day) {
    const daysOfWeek = [1, 2, 3, 4, 5]; // Mon->Fri
    return daysOfWeek.map(dayOfWeek =>
      moment(day)
        .isoWeekday(dayOfWeek)
        .format(TimeslotPicker.dayFormat),
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      day: moment(),
    };

    this.getPeriod = this.getPeriod.bind(this);
  }

  getPeriod() {
    if (this.props.displayPeriodLength === 'weeks') {
      return TimeslotPicker.weekFor(this.state.day);
    }
    return [moment(this.state.day).format(TimeslotPicker.dayFormat)];
  }

  // TODO: take styles out of Modal.css and into styled components.
  render() {
    const {
      timeslots,
      selected,
      setTimeslot,
      displayPeriodLength,
    } = this.props;
    const period = this.getPeriod();
    const groups = groupBy(timeslots, date =>
      moment(date).format(TimeslotPicker.dayFormat),
    );
    return (
      <div className="TimeslotPicker">
        <div className="TimeslotPicker__Day">
          <div className="TimeslotPicker__Timeslots">
            <button
              className={bem('TimeslotPicker__Selector', {
                prev: true,
                desktop: true,
              })}
              onClick={() =>
                this.setState({
                  day: moment(this.state.day).subtract(1, displayPeriodLength),
                })
              }
            >
              <IconArrowRight />
            </button>
          </div>
        </div>
        {!!period &&
          !!groups &&
          period.map(groupKey => (
            <div key={groupKey} className="TimeslotPicker__Day">
              <div className="TimeslotPicker__DayHeader">
                <button
                  className={bem('TimeslotPicker__Selector', {
                    prev: true,
                    mobile: true,
                  })}
                  onClick={() =>
                    this.setState({
                      day: moment(this.state.day).subtract(
                        1,
                        displayPeriodLength,
                      ),
                    })
                  }
                >
                  <IconArrowRight />
                </button>
                {moment(groupKey).format('ddd. MMM D')}
                <button
                  className={bem('TimeslotPicker__Selector', { mobile: true })}
                  onClick={() =>
                    this.setState({
                      day: moment(this.state.day).add(1, displayPeriodLength),
                    })
                  }
                >
                  <IconArrowRight />
                </button>
              </div>
              <div className="TimeslotPicker__Timeslots">
                {!!groups[groupKey] && (
                  <TimeslotGroup
                    group={groups[groupKey]}
                    selected={selected}
                    setTimeslot={setTimeslot}
                  />
                )}
              </div>
            </div>
          ))}
        <div className="TimeslotPicker__Day">
          <div className="TimeslotPicker__Timeslots">
            <button
              className={bem('TimeslotPicker__Selector', { desktop: true })}
              onClick={() =>
                this.setState({
                  day: moment(this.state.day).add(1, displayPeriodLength),
                })
              }
            >
              <IconArrowRight />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default TimeslotPicker;



// WEBPACK FOOTER //
// ./src/components/BookMarketerPage/components/TimeslotPicker/TimeslotPicker.jsx